export { mockAxiosError, textSpacer, optimizeFileStackURL, splitArrayIntoSets } from "@/plugins/formatters";
export { isAdmin, allowAccess } from "@/plugins/roles"; ;

export function objectIsEmpty(obj) {
    return (Object.keys(obj).length === 0 && obj.constructor === Object);
}

export function generateSlug() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 12; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

export function pushOrReplace(arr = [], value, predicateFn) {
    const foundIndex = arr.findIndex(predicateFn);
    if (foundIndex <= -1) {
        arr.push(value);
    } else {
        arr[foundIndex] = value;
    }
    return arr;
}

export function redirectWithReload(path = "") {
    if (path.startsWith("/") === false) {
        path = "/" + path;
    }
    if (process.browser) {
        window.location.href = window.location.origin + path;
    }
}

export function matchUrl(pattern = "", url = "") {
    pattern = pattern.startsWith("/") ? pattern : "/" + pattern;
    url = url.startsWith("/") ? url : "/" + url;

    const patternUrl = pattern.split("?")[0] || "";
    const patternParams = pattern.split("?")[1] || "";
    const urlUrl = url.split("?")[0] || "";
    const urlParams = url.split("?")[1] || "";

    const compareUrls = (urlOne = "", urlTwo = "") => {
        const urlOneParts = urlOne.split("/");
        const urlTwoParts = urlTwo.split("/");
        if (urlOneParts.length !== urlTwoParts.length) {
            return false;
        }

        for (let i = 0; i < urlOneParts.length; i++) {
            if (urlOneParts[i].startsWith(":") || urlTwoParts[i].startsWith(":")) {
                continue;
            }
            if (urlOneParts[i] !== urlTwoParts[i]) {
                return false;
            }
        }

        return true;
    };

    const compareParams = (paramsOne = "", paramsTwo = "") => {
        const paramsOneParts = paramsOne.split("&");
        const paramsTwoParts = paramsTwo.split("&");
        if (paramsOneParts.length !== paramsTwoParts.length) {
            return false;
        }

        for (let i = 0; i < paramsOneParts.length; i++) {
            const queryOne = (paramsOneParts[i] || "").split("=")[0] || "";
            const queryTwo = (paramsTwoParts[i] || "").split("=")[0] || "";

            if (queryOne !== queryTwo) {
                return false;
            }
        }

        return true;
    };

    if (!patternParams) {
        return compareUrls(patternUrl, urlUrl);
    } else {
        return compareUrls(patternUrl, urlUrl) && compareParams(patternParams, urlParams);
    }
}

export function goBackToLastUniqueRoute(query) {
    if (process.browser === false) {
        return;
    }

    const lastRoute = getLastUniqueRoute();
    if (lastRoute) {
        window.$nuxt.$router.push({ path: lastRoute.fullPath, query });
        return;
    }

    window.$nuxt.$router.go(-1);
}

export function getLastUniqueRoute() {
    if (process.browser === false) {
        return;
    }

    const currentPath = window.location.pathname;
    const previousRoutes = JSON.parse(window.localStorage.previousRoutes || "[]");

    for (let i = previousRoutes.length - 1; i >= 0; i--) {
        const previousRoute = previousRoutes[i] || {};
        if ((previousRoute.path.includes(currentPath) === false) && previousRoute.fullPath) {
            return previousRoute;
        }
    }
}

export function waitTill({ predicate = () => true, counts = 10, interval = 400 }) {
    let intervalId;
    let count = 0;
    return new Promise((resolve, reject) => {
        try {
            const val = predicate();
            if (val) {
                resolve(val);
            }

            intervalId = setInterval(() => {
                count = count + 1;
                const val = predicate();
                if (val) {
                    resolve(val);
                    clearInterval(intervalId);
                } else if (count > counts) {
                    reject(mockAxiosError({ message: "Waiting timeout error. Action took too long" }));
                    clearInterval(intervalId);
                }
            }, interval);
        } catch (err) {
            reject(err);
        }
    });
}

export const nth = (value) => {
    if (value > 3 && value < 21) {
        return "th";
    }
    switch (value % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
    }
};

export function convertObjectToQueryString( obj ) {
    // return Object.keys( obj ).map(key => key + '=' + obj[key]).join('&');
    var str = [];
    for (var p in obj) {
      
        if( obj[p] === undefined ) { 
            continue;
        }
      
        if (obj.hasOwnProperty(p)) {
            str.push((p) + "=" + (obj[p]));
        }
    }
    
    return str.join("&");
}

export function transformQueryToString( url = "", queryParams = undefined ) {
    let queryString = url;
    if (queryParams) queryString += "?" + convertObjectToQueryString( queryParams );
    
    return queryString;
}

/**
 * @param  {object} queryObj example: serialize({
  foo: "hi there",
  bar: {
    blah: 123,
    quux: [1, 2, 3]
  }
}
 * @returns {string} example: foo=hi%20there&bar=100%25
 */
export function serilaizeQuery(queryObj) {
    let str = [];
    for (let p in queryObj)
        if( queryObj[p] === undefined ) { 
            continue;
        }

    if (queryObj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(queryObj[p]));
    }
    return str.join("&");
}

/**
 * @param  {object} routeData
 * @param  {object} pageData 
}
 * @returns {{
        page: number,
        email: string,
        name: string,
    }}
 */
export function assembleQueryList(pageData) {
    const queryObj = {};

    if (pageData?.page) {
        if (typeof pageData.page === "number") {
            queryObj.page = pageData.page;
        }

        if (typeof pageData.page === "string") {
            queryObj.page = parseInt(pageData.page);
        }
    } 

    const pageDataEntries = Object.entries(pageData);

    for (let [key, prop] of pageDataEntries) {
        if (key && (prop || prop?.length)) {
            queryObj[key] = prop;
        }
    }

    return queryObj;
}

export function sortList(sortingType, arr, valueToSortBy) {
    arr.sort((a, b) => {
        var lowerValue = a[valueToSortBy].toLowerCase(); // ignore upper and lowercase
        var higherValue = b[valueToSortBy].toLowerCase();

        if (lowerValue < higherValue) {
            return sortingType === "Ascending" ? -1 : 1;
        } else if (lowerValue > higherValue) {
            return sortingType === "Ascending" ? 1 : -1;
        } 
    }); 
}

export function setItemOnLS(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
};

export function getItemOnLS(key) {
    localStorage.getItem(key);
};

export function clearDataOnLs(key) {
    window.localStorage.removeItem(key);
}

export function setItemOnSS(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
};

export function debounce(fn, ms = 1000) {
    clearTimeout(window.debounceId);
  
    window.debounceId = setTimeout(fn, ms);
}

export function validateEmail(value) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)?(gmail\.com|[a-zA-Z0-9-]+\.(com|eu|ng|uk|us))$/;
    return emailRegex.test(value);
}

export function validatePassword(val) {
    if (
        val.length > 8 || 
        /[A-Z]/.test(val) || 
        /[a-z]/.test(val) ||
        /\d/.test(val) || 
        /[!@#$%^&*(),.?":{}|<>]/.test(val)
    ) {
        return true;
    } else {
        return false;
    }
}

export function convertStringAmountToInt(str) {
    if (!str) return 0;

    const val = str.split(",").join("");
    return Number(val);
}

export function groupList(list = [], keyGetterFunc) {   
    if (!keyGetterFunc || !list) return;
    
    const map = new Map();

    list.forEach(item => {
        const key = keyGetterFunc(item);
        const collection = map.get(key);

        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

export function generateInvoiceRefNumber() {
    const baseChar = "01234567";
    let generatedNum = "";
    const length = 6;

    for (let i = length; i > 0; --i) {
        generatedNum += baseChar[Math.floor(Math.random() * baseChar.length)];
    }

    return generatedNum;
}

export function buildMap(arr = []) {
    const map = {};
    
    for (const val of arr) {
        map[val.code] = val;
    }
    return map;
}

export function buildCustomRecurrence(options) {
    let rule = "RRULE:FREQ=" + options.frequency;
  
    if (options.interval > 1) {
        rule += ";INTERVAL=" + options.interval;
    }
  
    if (options.count) {
        rule += ";COUNT=" + options.count;
    }
  
    if (options.until) {
    // Format date as YYYYMMDD
        const until = options.until.toISOString().replace(/[-:]/g, "").split("T")[0];
        rule += ";UNTIL=" + until + "T000000Z";
    }
  
    if (options.byDay && options.byDay.length > 0) {
        rule += ";BYDAY=" + options.byDay.join(",");
    }
  
    return rule;
}

export function isFilterValueEmpty(value) {
    if (!value) return true;

    if (value && typeof value === "object") {
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        return Object.values(value).every(v => !v);
    }

    if (typeof value === "string") {
        return value === "";
    }
}

export function buildCardDetails(cardData, cardBin, currency) {
    const [expiry_month, expiry_year] = cardData.ccExpiry.split("∕");

    const authorization = {
        address: cardData.billingAddress || "",
        country: cardData.billingCountry || "",
        city: cardData.billingCity || "",
        state: cardData.billingState || "",
        zipcode: cardData.postalCode || "",
    };

    const { card_type, issuing_country } = cardBin;

    return {
        authorization,
        card_type,
        issuing_country: issuing_country || cardData.billingCountry,
        card_number: cardData.cardNumber.replaceAll(" ", ""),
        currency,
        cvv: cardData.cvv,
        expiry_month,
        expiry_year,
        fullname: cardData.cardName,
    };
}

export function calculateTotalPages(total, pageSize) {
    if (!pageSize || pageSize <= 0) {
        return 1;
    }
    return Math.ceil(total / pageSize);
};